import React from 'react'
import { Box, createStyles, makeStyles } from '@material-ui/core'
import { Colors, Typography } from 'src/components/atoms'
import { useGlobalStyles } from 'src/styles/theme'

const useStyles = makeStyles(() =>
  createStyles({
    list: {
      margin: '0px',
      paddingInlineStart: '24px'
    }
  })
)

export const AfterSent = ({ email }: { email: string }) => {
  const classes = useStyles()
  const globalClasses = useGlobalStyles()

  return (
    <Box color={Colors.base.black}>
      <Typography variant="h1" fontSize="xxl" fontWeight="bold">
        ご本人確認のメールを送信しました
      </Typography>
      <Box height="20px" />
      <Typography variant="body2" fontSize="s" lh="relaxed">
        ご入力頂いたメールアドレス（{email}
        ）に、認証メールを送信しました。メールをご確認いただき、本登録を完了してください
      </Typography>
      <Box height="32px" />
      <Typography variant="body2" fontSize="s" lh="relaxed">
        本人確認メールを受信後、24時間以内に認証を行わない場合はご登録が無効となります。その際は再度ご登録お願いします
      </Typography>

      <Box height="20px" />

      <Box bgcolor={Colors.background.lightGray} borderRadius="10px" p="20px 16px">
        <Typography variant="body2" fontSize="s" fontWeight="bold">
          <span className={globalClasses.fontEmoji} style={{ marginRight: '6px' }}>
            &#x26A0;
          </span>
          メールが届かない場合
        </Typography>
        <Box height="22px" />
        <Box component="ul" className={classes.list}>
          <Box component="li" mb="17px">
            <Typography variant="body2" fontSize="s" lh="tight">
              メールアドレスに誤りがないか、ご確認ください
            </Typography>
          </Box>
          <Box component="li" mb="17px">
            <Typography variant="body2" fontSize="s" lh="tight">
              「noco.sale」ドメインからの メールを受信できるように設定してください
            </Typography>
          </Box>
          <Box component="li" mb="17px">
            <Typography variant="body2" fontSize="s" lh="tight">
              ご利用のメールサービスの迷惑メールフォルダに届いていないかご確認ください
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
